import axios from "./axios";

export default {
    info () {
        return axios.get('/api/v1/auth/info');
    },

    userInfo () {
        return axios.get('/api/v1/user/info');
    },
    sendConfirmationLetter (userId, resend = false) {
        return axios.post('/api/v1/user/' + userId + '/confirm-email', {resend: resend});
    },
    validateConfirmCode (code, userId) {
        return axios.post('/api/v1/user/' + userId + '/validate-confirmation-code', {code: code});
    },
}
